import { Form } from '@iheartjane/reefer-hook-form';
import { useMaskito } from '@maskito/react';
import type { ControllerRenderProps, FieldValues, Path } from 'react-hook-form';

import { isValidUrl, urlMask } from '@jane/business-admin/util';

import styles from './UrlInput.module.css';

interface UrlInputProps<TFieldValues extends FieldValues> {
  field: ControllerRenderProps<TFieldValues, Path<TFieldValues>>;
  placeholder?: string;
}

export const UrlInput = <TFieldValues extends FieldValues>({
  field,
  placeholder = 'Add URL',
}: UrlInputProps<TFieldValues>) => {
  const urlRef = useMaskito({ options: urlMask });
  const safeValue =
    field.value === null || field.value === undefined ? '' : field.value;

  return (
    <Form.TextField
      className={styles['urlField']}
      {...field}
      label=""
      labelHidden
      value={safeValue}
      defaultValue={safeValue}
      placeholder={placeholder}
      width="100%"
      ref={(el) => {
        field.ref(el);
        urlRef(el);
      }}
      validate={(value) => {
        if (!value) return true;
        return isValidUrl(value as string)
          ? true
          : 'Invalid URL - must include a domain (e.g., .com, .org)';
      }}
    />
  );
};
